import { useEffect, useState } from 'react'
import {
  Stack,
  Button,
  Text,
  Image,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  useDisclosure,
  DrawerBody,
  List,
  ListItem,
  ListIcon
} from '@chakra-ui/react'
import { CheckIcon } from '@chakra-ui/icons'

import useChannel from '../hooks/useChannel'

import ReturnDrawerMobile from './ReturnDrawerMobile'
import useAuth from '../hooks/useAuth'

const ListChannel = ({ title, sizeS, survey, setSurvey }) => {
  const { userRegister } = useAuth()
  const { preferences } = userRegister
  const [selected, setSelected] = useState('')
  const [size, setSize] = useState('')

  const { isOpen, onOpen, onClose } = useDisclosure()
  const [channels] = useChannel()

  const quilmesImages = require.context('../assets/images', true)

  useEffect(() => {
    if (preferences === null) {
      return
    }
    setSelected(preferences.channel.description)
  }, [preferences])
  /**
   * It takes a newSize as an argument, sets the size to the newSize, and then calls the onOpen
   * function
   * @param newSize - The new size of the modal.
   */
  const handleClick = (newSize) => {
    setSize(newSize)
    onOpen()
  }

  /**
   * It takes a newSelected value, sets the selected value to the newSelected value, and sets the
   * survey channel to the newSelected value
   * @param newSelected - the new selected value
   */
  const handleSelect = (newSelected) => {
    setSelected(newSelected)
    setSurvey({ ...survey, channel: newSelected })
  }
  const { channel } = survey

  return (
    <Stack>
      <Button
        key={size}
        display={'flex'}
        fontWeight={500}
        justifyContent={'space-between'}
        variant='outline'
        onClick={() => handleClick(sizeS)}
      >
        <Text>{channel === '' ? `${title} *` : channel} </Text>
        <Image src={quilmesImages('./Vector.svg')} width={'12px'} />
      </Button>

      <Drawer isOpen={isOpen} maxWidth={'100%'} size={sizeS} onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <ReturnDrawerMobile onClose={onClose} />
          <DrawerBody paddingTop={10}>
            <List spacing={4}>
              {channels
                .sort((a, b) =>
                  a.description.toLowerCase() < b.description.toLowerCase()
                    ? -1
                    : 1
                )
                .map((item) => (
                  <ListItem
                    key={item.channelId}
                    display={'flex'}
                    justifyContent={'space-between'}
                    textTransform={'capitalize'}
                    value={item.description}
                    onClick={() => handleSelect(item.description)}
                    {...(selected === item.description
                      ? { color: '#DB580B' }
                      : {})}
                  >
                    {item.description}
                    {selected === item.description && (
                      <ListIcon
                        as={CheckIcon}
                        color={'#DB580B'}
                        marginTop={'.3rem'}
                      />
                    )}
                  </ListItem>
                ))}
            </List>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Stack>
  )
}

export default ListChannel
